import React from "react";
import IMAGES from "../../constants/images";

export default function NoAppointments({ compact = false }) {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center ${
        compact ? "p-2" : "p-3"
      }`}
    >
      {/* Image */}
      <img
        src={IMAGES.no_appointment}
        alt="No Appointments"
        className={compact ? "h-[64px] mb-2" : "h-22 mb-6"}
      />

      {/* Heading */}
      <h2
        className={`font-semibold text-[#4B61FF] font-poppins ${
          compact ? "text-sm mt-2 mb-1" : "text-lg mt-6 mb-4"
        }`}
      >
        No upcoming appointments yet.
      </h2>

      {/* Description */}
      <p
        className={`text-[#334155] font-poppins ${
          compact ? "text-xs mb-0" : "text-sm"
        }`}
      >
        Once your availability is set, patients can start booking with you
      </p>
    </div>
  );
}
